import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import './menu.css'

const Menu = (props) => {
  const { created, user } = props;
  return (
    <div className={`menu-container ${props.rootClassName} `}>
      {user.uid && (
        <Fragment>
          <Link to="/advices" className='menu-button-container'>
            <button className="button menu-button">
              <span className="menu-text1">Advices</span>
            </button>
          </Link>
          {!created && (
            <Link to="/photo-instructions" className="menu-camera-container" >
              <img alt={props.image_alt} src={props.image_src} className="menu-image" />
            </Link>
          )}
          <Link to="/calendar" className='menu-button-container'>
            <button className="button menu-button1">
              <span className="menu-text1">Log</span>
            </button>
          </Link>
        </Fragment>
      )}
    </div>
  )
}

Menu.defaultProps = {
  image_alt: 'image',
  button: 'Advices',
  image_src: '/playground_assets/camera.png',
  rootClassName: '',
}

Menu.propTypes = {
  image_alt: PropTypes.string,
  button: PropTypes.string,
  image_src: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default Menu
